export enum eFolderFeature {
  apiPath = '/archived-folders',
  archivedFolderPath = '/archived-folder',
  archivedAuditsPath = '/archived-audits',
  unarchivedAuditsPath = '/unarchived-audits',
}
